<template>
  <div id="header-document-detail">
    <div id="document-meta">
      <h4 v-if="has_tituloarticulo" id="titulo-articulo">
        {{ tituloarticulo }}
      </h4>
    </div>
    <modal-quick-view-vue :bus="bus" :copy-buttons-visible="true"/>
    <div v-if="visibleFields.length > 0">
      <div class="d-flex">
        <span class="label font-weight-bold">
          {{ field_label(visibleFields[0]) }}
        </span>
        <span class="ml-1" v-html="visibleFields[0].value" />
      </div>
      <div ref='extra_headers' v-if="haveExtraHeaders()" class="header-fields">
        <div class="collapse show" id="collapseHeaders">
          <div class="">
            <div
              v-for="header in extraHeaders()"
              :class="header_field_class(header)"
              :key="get_header_key(header.id)"
            >
              <div class="d-flex">
                <span class="label mt-2 font-weight-bold">
                  {{ field_label(header) }}
                </span>
                <div class="mt-2 ml-1" v-html="headerWithLinks(header)" />
              </div>
            </div>
          </div>
        </div>
        <a
          id="see-less-toggle"
          class="text-primary"
          data-toggle="collapse"
          href="#collapseHeaders"
          role="button"
          aria-expanded="false"
          aria-controls="collapseHeaders"
          @click="seeMoreToggle"
        >
          {{ seeMoreLabel }}
          <i :class="seeMoreIcon"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { fetchLinks, textProcessor } from 'common/links'

export default {
  name: "documents-document-header-vue",
  props: {
    tituloarticulo: { type: String, default: "" },
    header_fields: { type: Array, default: () => [] },
    document_id: { type: String, default: "" }
  },
  components: {
    "modal-quick-view-vue": () => import(/* webpackChunkName: "[request]" */ "components/ModalQuickView")
  },
  data() {
    return {
      bus: new Vue(),
      toggle: true,
      linksData: {}
    };
  },
  computed: {
    visibleFields() {
      return this.header_fields.filter(field => field.id != 'titulo')
    },
    has_tituloarticulo() {
      return !!this.tituloarticulo
    },
    seeMoreLabel() {
      return this.toggle
        ? I18n.t("components.documents.header.see_less")
        : I18n.t("components.documents.header.see_more")
    },
    seeMoreIcon() {
      return this.toggle
        ? "fas fa-angle-double-up"
        : "fas fa-angle-double-down";
    }
  },
  methods: {
    header_field_class: ({ id, normalized_value }) =>
      normalized_value ? `header_field_${id}_${normalized_value}` : "",
    get_header_key: (id) => `header_field_${id}`,
    field_label(header) {
      let label = header.label
      return label + (header.value_type == "boolean" ? "" : ":")
    },
    seeMoreToggle() {
      this.toggle = !this.toggle
    },
    haveExtraHeaders(){
      return this.visibleFields.length > 1
    },
    extraHeaders(){
      return this.visibleFields.slice(1)
    },
    showQuickView(id){
      this.bus.$emit("quick_view:show_document", id, '')
    },
    async loadLinks() {
      this.linksData = await fetchLinks(this.document_id)
    },
    headerWithLinks(headerValue){
      if(this.linksData[headerValue.id]){
        return textProcessor(gon.paisiso, headerValue.value, this.linksData[headerValue.id])
      }
      return headerValue.value
    }
  },
  mounted() {
    this.loadLinks()
    if(this.haveExtraHeaders()){
      this.$refs['extra_headers'].firstChild.addEventListener('click', (event) => {
        let docid = event.target.dataset.docid
        if(docid){
          event.preventDefault()
          this.showQuickView(docid)
        }
      })
    }
  },
  beforeDestroy() {
    this.$refs['extra_headers'].firstChild.removeEventListener("click")
  }
};
</script>
